import React, { useState } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';

import eyeIcon from '../../images/eye.svg';
import eyeOffIcon from '../../images/eye-off.svg';
import messages from './messages';

interface ControllerFiledPasswordProps {
  name: string;
  placeholder: string;
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  helpText?: string;
  children?: React.ReactNode;
}

const ControllerFiledPassword = ({
  name,
  placeholder,
  value,
  handleChange,
  handleFocus,
  error,
  helpText,
  children,
}: ControllerFiledPasswordProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const intl = useIntl();

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  return (
    <div className="auth-input-group">
      <input
        id={name}
        className="auth-input password"
        name={name}
        placeholder={placeholder}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
      />
      {error && (
        <p className="auth-input-error">
          {error}
        </p>
      )}
      {helpText && (
        <div className="text-helper">
          {helpText}
        </div>
      )}
      {children}
      <button
        type="button"
        className="password-eye-block"
        onClick={togglePasswordVisibility}
      >
        <img
          loading="lazy"
          className="password-eye-icon"
          src={showPassword ? eyeIcon : eyeOffIcon}
          alt={intl.formatMessage(showPassword ? messages.showPassword : messages.hidePassword)}
        />
      </button>
    </div>
  );
};

export default ControllerFiledPassword;
